import vueUtil from '@/CVI/WebCore/vue-util'
import CustomerWebUserCockpitLoader from '@/CVI/CustomerWeb/components/UserCockpitLoader.vue'

const components = {
  CustomerWebUserCockpitLoader
}

vueUtil.mountComponents(components)
